import { SparkIcon, Skeleton } from '@spark';

const MIN_WIDTH = 15; // Minimum width in pixels to show the number

export const ProcessedDataTable = ({ processedTrainsetInfo, loading }) => {
    if (!processedTrainsetInfo) return null;

    const { totalRecords, greatQuality, mediumQuality, lowQuality } = {
        totalRecords: processedTrainsetInfo.num_rows_entries,
        greatQuality: processedTrainsetInfo.num_greens,
        mediumQuality: processedTrainsetInfo.num_oranges,
        lowQuality: processedTrainsetInfo.num_reds
    };

    const QualityBar = ({ loading, count, color, total }) => {

        // Calculate percentage width
        let widthPercentage = (loading || total === 0) ? 35 : (count / total) * 100;

        // If count is 0, still show a minimal bar with "0"
        const displayStyle = {
            width: count === 0 ? MIN_WIDTH : `max(${MIN_WIDTH}px, ${widthPercentage}%)`,
            backgroundColor: color,
            height: '24px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: 'white',
            fontSize: '13px',
            fontWeight: '500',
            minWidth:`${MIN_WIDTH}px`
        };

        return (
            <div style={displayStyle}>
                {loading ? <Skeleton shapeType="circle" width={24} height={24} /> : count}
            </div>
        );
    };
    
    return (
        <div>
            {/* TODO: remove from comment after scoring is implemented */}
            {/* {(loading || totalRecords !== undefined) && <div style={{
                background: '#1f1f1f',
                borderRadius: '8px',
                padding: '16px',
                marginBottom: '24px'
            }}>
                <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    marginBottom: '16px'
                }}>
                    <h5 style={{
                        color: 'white',
                        margin: 0,
                        marginRight: '8px',
                        fontSize: '16px',
                        fontWeight: 600
                    }}>
                        Processed Train Set Info
                    </h5>
                    <span style={{ color: '#8c8c8c' }}><SparkIcon slug="info" size="small" /></span>
                </div>

                <div style={{ marginBottom: '12px' }}>
                    <span style={{ color: '#8c8c8c' }}>
                        # Raw Entries: {totalRecords}
                    </span>
                </div>

                <div style={{
                    display: 'flex',
                    height: '24px',
                    borderRadius: '4px',
                    overflow: 'hidden'
                }}>
                    <QualityBar
                        quality="Low"
                        count={lowQuality}
                        color="#ff4d4f"
                        total={greatQuality + mediumQuality + lowQuality}
                        loading={loading}
                    />
                    <QualityBar
                        quality="Medium"
                        count={mediumQuality}
                        color="#faad14"
                        total={greatQuality + mediumQuality + lowQuality}
                        loading={loading}
                    />
                    <QualityBar
                        quality="Great"
                        count={greatQuality}
                        color="#52c41a"
                        total={greatQuality + mediumQuality + lowQuality}
                        loading={loading}
                    />
                </div>

                <div style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    marginTop: '8px'
                }}>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <div style={{
                            width: '8px',
                            height: '8px',
                            backgroundColor: '#ff4d4f',
                            borderRadius: '50%',
                            marginRight: '4px',
                            flexShrink: 0 // Prevent the indicator from shrinking
                        }} />
                        <span style={{ color: '#8c8c8c', fontSize: '12px' }}>Low Quality</span>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <div style={{
                            width: '8px',
                            height: '8px',
                            backgroundColor: '#faad14',
                            borderRadius: '50%',
                            marginRight: '4px'
                        }} />
                        <span style={{ color: '#8c8c8c', fontSize: '12px' }}>Medium Quality</span>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <div style={{
                            width: '8px',
                            height: '8px',
                            backgroundColor: '#52c41a',
                            borderRadius: '50%',
                            marginRight: '4px'
                        }} />
                        <span style={{ color: '#8c8c8c', fontSize: '12px' }}>Great Quality</span>
                    </div>
                </div>
            </div>} */}
        </div>
    );
};